/* eslint-disable no-unreachable */
/**
 * Validators for common input types
 */
import _ from 'lodash';
import { checkEmailAvailability, checkUsernameAvailability, checkUsernamesAndEmailsAvailability } from '../../../common/api';
import log from 'common/Logger';
const alphaNumericRegex = /^[a-zA-Z0-9]/
const usernameRegex = /^[a-zA-Z0-9_-]/
const fullUsernameRegex = /^[a-zA-Z0-9_-\s]+$/
const phoneNumberRegex = /^[+]?\d+$/

export async function validateEmail(email, serverValidation = true) {
	if (_.isEmpty(email)) return true;
	//check if email exists in DB
	const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	if (emailRegex.test(email)) {
		if (!serverValidation) return true;
		try {
			const { success, message } = await checkEmailAvailability(email)
			if (success) return true;
			return message;
		} catch (e) {
			log.error('validateEmail -> checkEmail api call failed');
			return true;
		}
	} else {
		return 'Email address is invalid'
	}
}

export async function validateUsername(username, serverValidation = true) {
	// if (_.isEmpty(username)) return 'cannot be empty';
	if (username.length > 60) return 'cannot be longer than 60 characters';
	//check if username exists in DB
	if (!usernameRegex.test(username)) {
		return 'only English letters, numbers and "_" or "-" are allowed';
	}
	if (!serverValidation) return true;
	try {
		const { success, message } = await checkUsernameAvailability(username)
		if (success) return true;
		return message.replace('Username', `'${username}'`);
	} catch (e) {
		log.error('validateUsername -> checkUserName api call failed');
		return true;
	}
}

export function validateFullusername(username) {
	// if (_.isEmpty(username)) return 'cannot be empty';
	if (username.length > 60) return 'cannot be longer than 60 characters';
	//check if username matches rule
	if (!fullUsernameRegex.test(username)) {
		return 'only English letters, numbers and "_" or "-" are allowed';
	}
	return true;
}

export async function validateUsernamesAndEmails(usernamesAndEmails) {
	try {
		const result = await checkUsernamesAndEmailsAvailability(usernamesAndEmails)
		return result;
	} catch (e) {
		log.error('validateUsernamesAndEmails -> checkUsernamesAndEmails api call failed');
		return null;
	}
}

export function validateName(name) {
	if (_.isEmpty(name)) return true;
	if (alphaNumericRegex.test(name)) {
		return true;
	} else {
		return 'must contain only English letters or numbers'
	}
}

export function validatePassword(password) {
	const alphaPat = /[a-z]/i;
	const numPat = /[0-9]/;
	let isLongEnough = false;
	let isShortEnough = false;
	let hasAlphas = false;
	let hasNumbers = false;
	if (alphaPat.test(password)) {
		hasAlphas = true;
	} else {
		return 'must contain at least one English letter (A-Z)'
	}
	if (numPat.test(password)) {
		hasNumbers = true;
	} else {
		return 'must contain at least one digit (0-9)'
	}
	if (password.length > 7) {
		isLongEnough = true;
	}
	if (password.length < 8) {
		return 'must be at least 8 characters long'
	}
	if (password.length < 65) {
		isShortEnough = true;
	} else {
		return 'should be less than 65 characters long'
	}
	if (isLongEnough && isShortEnough && hasAlphas && hasNumbers) {
		return true;
	}
}

export function validatePhoneNumber(phoneNumber) {
  if (phoneNumberRegex.test(phoneNumber)) {
    return true;
  } else {
    return "Phone number is invalid";
  }
}